export enum Patterns {
  /** Update backend's RegexPatterns.Phone on any change, inspired by https://stackoverflow.com/a/33561517 */
  Phone = '^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\\s./0-9]{8,14}$',
  OTP = '^[0-9]{6}$',
  Price = '^[+-]?[1-9]+(.[0-9]+)?$',
  /** Include specific month length and leap years */
  Date = '^(?:(?:31\\/(?:0[13578]|1[02]))|(?:(?:29|30)\\/(?:0[13-9]|1[0-2])))\\/(?:19|20)\\d{2} (?:[01]\\d|2[0-3]):[0-5]\\d$',
  Integer = '^-?[0-9]+$',
  Digits = '^\\d+$',
  CommaNumber = '^-?[0-9]+,?[0-9]+$',
}
